/* Attikar Size Guide — turns pipe-text size tabs into a styled table + cm/inch toggle.
   Source of truth: this file. Pure functions are also require()-able in Node for testing. */
(function (root) {
  'use strict';

  var SIZES = /^(XXS|XS|S|M|L|XL|XXL|XXXL|[2-9]XL|ONE SIZE|OS|FREE)$/i;
  var SYSTEM_KEYS = /^(US|EU|UK|AU|JP|INT)$/i;            // never unit-convert these
  var NONLEN_UNIT = /(kg|lbs|g)\b/i;                       // weight: ignore for cm/in toggle

  function stripHtml(s) {
    s = String(s == null ? '' : s);
    s = s.replace(/<\s*(br|\/p|\/li|\/div|\/h[1-6]|\/tr)\s*\/?>/gi, '\n');
    s = s.replace(/<[^>]+>/g, '');
    s = s.replace(/&nbsp;/gi, ' ').replace(/&amp;/gi, '&')
         .replace(/&lt;/gi, '<').replace(/&gt;/gi, '>')
         .replace(/&#39;|&rsquo;|&#x27;/gi, "'").replace(/&quot;/gi, '"')
         .replace(/&ndash;|&#8211;/gi, '-').replace(/&mdash;|&#8212;/gi, '-');
    return s;
  }

  function parseCell(cell) {
    cell = cell.trim();
    // "Length: 60.5cm" (colon-separated key/value)
    var mc = cell.match(/^([A-Za-z][A-Za-z.\/'’ ]*?)\s*:\s*([0-9].*)$/);
    if (mc) return { key: mc[1].trim(), val: mc[2].trim() };
    // "Bust 82" (space-separated)
    var m = cell.match(/^([A-Za-z][A-Za-z.\/'’ ]*?)\s+([0-9].*)$/);
    if (m) return { key: m[1].trim(), val: m[2].trim() };
    // bare value "145", "22.5cm"
    if (/^[0-9]/.test(cell)) return { key: '', val: cell };
    return { key: cell, val: '' };
  }

  function isNote(line) {
    var l = line.toLowerCase();
    if (l.indexOf('size guide') === 0) return false; // handled as caption
    return /please allow|manual measurement|measured by hand|may vary|refer to|we want you|care instructions|designed with|measure inner|for best fit|recommend|^\*/.test(l)
        || (!/[0-9]/.test(line) && line.split('|').length < 2);
  }

  function detectUnit(s) {
    if (/mm\b/i.test(s)) return 'mm';
    if (/cm\b/i.test(s)) return 'cm';
    if (/\b(in|inch|inches)\b/i.test(s)) return 'in';
    return null;
  }
  function computeFill(rows, cols) {
    if (!rows.length || !cols.length) return 1;
    var total = rows.length * cols.length, filled = 0;
    rows.forEach(function (r) {
      var m = {}; r.cells.forEach(function (c, i) { m[c._col || ('Col' + i)] = c.val; });
      cols.forEach(function (col) { if (m[col]) filled++; });
    });
    return filled / total;
  }
  function colNameFromCaption(caption) {
    var m = String(caption).match(/\(([^)]+)\)/);
    if (!m) return 'Measurement';
    var w = m[1].replace(/recommended|standard|approx\.?/ig, '').trim().split(/\s+/);
    return (w[w.length - 1] || 'Measurement').replace(/^./, function (c) { return c.toUpperCase(); });
  }

  // Parse raw HTML/text into a structured guide. Returns {tabular:false} when not a table.
  var SIZE_ONLY = /^(XXS|XS|S|M|L|XL|XXL|XXXL|[2-9]XL|ONE SIZE|OS|FREE)$/i;
  var NOISE_PREFIX = /^(please note|fit note|tip|note|important|sizing tip|disclaimer|refer to|we want you|still unsure|how to measure|measurement guide)\b/i;

  function isSectionHeader(line) {
    if (/[0-9:|]/.test(line)) return false;
    if (/^size\b/i.test(line)) return false; // "Size S" etc. are group headers, not sections
    if (/^(one\s*size|free\s*size|os)\b/i.test(line)) return false;
    if (NOISE_PREFIX.test(line)) return false;
    if (SIZE_ONLY.test(line)) return false;
    if (SIZE_ONLY.test(line.replace(/\s*\(.*\)\s*/, '').trim())) return false; // "S (Small)" is a group, not a section
    var w = line.split(/\s+/);
    return w.length <= 6 && line.length <= 45 && /^[A-Za-z][A-Za-z &()/'\-]*$/.test(line);
  }

  function parseGuide(raw) {
    var txt = stripHtml(raw);
    var lines = txt.split('\n').map(function (l) { return l.replace(/\s+/g, ' ').trim(); })
                   .filter(function (l) { return l.length; });
    if (!lines.length) return { tabular: false };

    var caption = '', capUnit = null, notes = [];
    var sections = [], cur = null, curGroup = null;

    function section() {
      if (!cur) { cur = { title: '', sizeRows: [], specRows: [] }; sections.push(cur); }
      return cur;
    }
    function flushGroup() {
      if (curGroup && curGroup.cells.length) section().sizeRows.push(curGroup);
      curGroup = null;
    }
    function newSection(title) {
      flushGroup();
      if (cur && !cur.sizeRows.length && !cur.specRows.length) { cur.title = title; }
      else { cur = { title: title, sizeRows: [], specRows: [] }; sections.push(cur); }
    }
    function cellsFromPipes(rest) {
      return rest.split(/[|,]/).map(function (c) { return parseCell(c); })
                 .filter(function (c) { return c.key || c.val; });
    }

    lines.forEach(function (line) {
      line = line.replace(/^[\s\u2022\u2023\u25CF\u25AA\u2024\u00B7\*\u2600-\u27BF\uFE0F\u200D\u{1F000}-\u{1FAFF}]+/u, '');

      // Normalize full-word sizes (SMALL/MEDIUM/LARGE/X-LARGE) to S/M/L/XL when used as a size label
      var fwm = line.match(/^((?:XXX|XX|X)[-\s]?)?(SMALL|MEDIUM|LARGE)\b(.*)$/i);
      if (fwm && (fwm[3] === '' || /^\s*[(:|\u2013\u2014\-]/.test(fwm[3]))) {
        var pre = (fwm[1] || '').toUpperCase().replace(/[^X]/g, '').length;
        var base = fwm[2].toUpperCase();
        line = (base === 'MEDIUM' ? 'M'
              : base === 'SMALL' ? ['S', 'XS', 'XXS', 'XXXS'][pre]
              : ['L', 'XL', '2XL', '3XL'][pre]) + fwm[3];
      }
      // Collapse dual-unit "12 cm | 4.7 in" (pipe-separated imperial twin) to the metric value;
      // the CM/INCHES toggle regenerates inches, so the stored inch copy is redundant.
      line = line.replace(/(\d\s*(?:cm|mm))\s*\|\s*[\d.\s\u2013\u2014\-]+(?:in|inch|inches|")\b/gi, '$1');

      var low = line.toLowerCase();
      if (low.indexOf('size guide') === 0 || low.indexOf('size chart') === 0) { caption = line; capUnit = detectUnit(line); return; }
      if (NOISE_PREFIX.test(line)) { flushGroup(); notes.push(line); return; }
      if (isSectionHeader(line)) { newSection(line); return; }

      // Repair labels glued to data: "M (Medium)Bust: 104cm | ..." -> "M — Bust: 104cm | ..."
      var glue = line.match(/^(XXS|XS|S|M|L|XL|XXL|XXXL|[2-9]XL)(?:\s*\([^)]*\))?([A-Z][a-z].*\|.*)$/);
      if (glue) line = glue[1] + ' \u2014 ' + glue[2];

      // "Size S: Bust 96 | ..." / "Size M (AU 12-14): ..." -> "S: ..." (a row, not a group header)
      var szp = line.match(/^size\s+((?:XXS|XS|S|M|L|XL|XXL|XXXL|[2-9]XL)(?:\s*\([^)]*\))?)\s*(?::|\u2192|->)\s*(.+)$/i);
      if (szp && /[0-9]/.test(szp[2])) line = szp[1] + ': ' + szp[2];

      // Pipe row whose FIRST cell is a bare size: "S | Bust: 105cm | Length: 85cm"
      if (line.indexOf('|') >= 0) {
        var pf = line.split('|');
        if (pf.length >= 2 && SIZE_ONLY.test(pf[0].trim())) {
          flushGroup();
          var pcs = cellsFromPipes(pf.slice(1).join('|'));
          if (pcs.length) { section().sizeRows.push({ label: pf[0].trim().toUpperCase(), cells: pcs }); return; }
        }
      }

      // Group header announced as a line: "Size: M", "Size 105/M", "Size 2XL (Recommended: 40-50kg)"
      var sh = line.match(/^size\b\s*:?\s*(.+)$/i);
      if (sh && !/^size guide/i.test(line)) {
        flushGroup();
        var slbl = sh[1].trim();
        var extra = [];
        var pr = slbl.match(/\(([^)]*)\)/);
        if (pr) {
          slbl = slbl.replace(/\s*\([^)]*\)\s*/, ' ').trim();
          var kvp = pr[1].match(/^\s*([A-Za-z][A-Za-z .]*?)\s*:\s*(.+?)\s*$/);
          extra.push(kvp ? { key: kvp[1].trim(), val: kvp[2].trim() }
                         : { key: 'Recommended', val: pr[1].trim() });
        }
        if (slbl.indexOf('|') >= 0) {
          var sp2 = slbl.split('|');
          slbl = sp2[0].trim();
          sp2.slice(1).forEach(function (seg) { var c = parseCell(seg.trim()); if (c.key || c.val) extra.push(c); });
        }
        curGroup = { label: slbl || '\u2014', cells: extra };
        return;
      }

      // Grouped size header: a size token alone, optionally "(Height: .. / Weight: ..)"
      var hdr = line.match(/^([A-Za-z0-9]{1,4})(?:\s*\((.*)\))?$/);
      if (hdr && SIZE_ONLY.test(hdr[1])) {
        flushGroup();
        curGroup = { label: hdr[1].toUpperCase(), cells: [] };
        if (hdr[2]) {
          hdr[2].split('/').forEach(function (seg) {
            var kv = seg.match(/^\s*([A-Za-z][A-Za-z .]*?)\s*:\s*(.+?)\s*$/);
            if (kv) curGroup.cells.push({ key: kv[1].trim(), val: kv[2].trim() });
          });
        }
        return;
      }

      // Within an open group: a pipe line of measures -> add all cells to the group
      if (curGroup && line.indexOf('|') >= 0 && /[0-9]/.test(line)) {
        cellsFromPipes(line).forEach(function (c) { curGroup.cells.push(c); });
        return;
      }

      // Inline size row: SIZE [:|–|—|-] pairs (label must look like a size/system)
      var inl = line.match(/^(.{1,40}?)(?:\s*:\s*|\s+[\u2013\u2014\-]\s+)(.+)$/);
      if (inl && inl[1].indexOf('|') < 0) {
        var label = inl[1].trim();
        var rest = inl[2].trim();
        var labelTok = label.replace(/\s*\(.*\)\s*/, '').trim();
        var firstTok = labelTok.split(/[\s\/]/)[0];
        var looksSize = SIZES.test(firstTok)
                     || /^(US|EU|UK|AU|JP|INT)\s*[0-9]/i.test(labelTok)
                     || /^(one\s*size|free\s*size|os|one)\b/i.test(labelTok)
                     || /^[0-9]{1,3}(?:\.[0-9])?$/.test(firstTok)
                     || /\|/.test(rest);
        if (looksSize && /[0-9]/.test(rest)) {
          var cells = cellsFromPipes(rest);
          if (cells.length) { flushGroup(); section().sizeRows.push({ label: label, cells: cells }); return; }
        }
      }

      // Measurement line "Bust: 54cm" / "Bust 54cm"
      var meas = line.match(/^([A-Za-z][A-Za-z .]{0,20}?)\s*:\s*(.+)$/)
              || line.match(/^([A-Za-z][A-Za-z .\/]{0,20}?)\s*[-\u2013]\s*([0-9].*)$/)
              || line.match(/^([A-Za-z][A-Za-z .]{0,20}?)\s+([0-9][0-9.,\/\u2013\-]*\s*(?:cm|mm|in|kg|lbs)?.*)$/);
      if (meas && /[0-9]/.test(meas[2]) && meas[2].split(/\s+/).length <= 8
          && !/\b(the|and|with|for|please|features|recommend|fits|maintain|allow|your)\b/i.test(meas[2])) {
        if (curGroup) { curGroup.cells.push({ key: meas[1].trim(), val: meas[2].trim() }); return; }
        section().specRows.push({ key: meas[1].trim(), val: meas[2].trim() }); return;
      }

      // Footwear pipe row with no leading size
      if (line.indexOf('|') !== -1 && /[0-9]/.test(line)) {
        var fc = cellsFromPipes(line);
        if (fc.length >= 2) { flushGroup(); section().sizeRows.push({ label: null, cells: fc }); return; }
      }

      notes.push(line);
    });
    flushGroup();

    if (!capUnit) {
      var blob = lines.join(' ');
      if (/mm\b/i.test(blob)) capUnit = 'mm';
      else if (/cm\b/i.test(blob)) capUnit = 'cm';
    }

    function buildSection(sec) {
      var rows = sec.sizeRows.filter(function (r) { return r.cells.some(function (c) { return c.val; }); });
      if (rows.length) {
        // confidence gate per section
        var counts = {}, pipeLabel = false;
        rows.forEach(function (r) {
          if (r.label && r.label.indexOf('|') >= 0) pipeLabel = true;
          var k = (r.label || '').replace(/\s*\(.*\)/, '').trim().toUpperCase();
          if (SIZE_ONLY.test(k)) counts[k] = (counts[k] || 0) + 1;
        });
        if (pipeLabel) return null;
        if (Object.keys(counts).some(function (k) { return counts[k] > 1; })) return null;

        var hasLabel = rows.some(function (r) { return r.label != null; });
        var bareName = colNameFromCaption(caption);
        var cols = [];
        rows.forEach(function (r) {
          r.cells.forEach(function (c, i) {
            var k = c.key || (r.cells.length === 1 ? bareName : ('Col' + i));
            c._col = k;
            if (cols.indexOf(k) === -1) cols.push(k);
          });
        });
        var fill = computeFill(rows, cols);
        // drop columns with no values at all (e.g. a stray "Raglan Sleeves")
        cols = cols.filter(function (col) {
          return rows.some(function (r) {
            return r.cells.some(function (c) { return (c._col || '') === col && c.val; });
          });
        });
        if (cols.length > 6 && fill < 0.35) return null;
        return { title: sec.title, kind: 'sizes', hasLabel: hasLabel, columns: cols, rows: rows };
      }
      if (sec.specRows.length >= 2) {
        return { title: sec.title, kind: 'spec', rows: sec.specRows };
      }
      return null;
    }

    var out = sections.map(buildSection).filter(Boolean);
    out = pivotSections(out);
    if (!out.length) return { tabular: false };
    return { tabular: true, caption: caption, capUnit: capUnit, notes: notes, sections: out };
  }

  // If every section is a single-measurement table keyed by the same sizes (a transposed
  // layout: "Length" S..2XL, "Bust" S..2XL, ...), combine into ONE table with the section
  // titles as columns. Multi-column sections (Top/Pants sets) are left as separate tables.
  function pivotSections(secs) {
    if (secs.length < 2) return secs;
    var ok = secs.every(function (s) {
      return s.kind === 'sizes' && s.hasLabel && s.title && s.columns && s.columns.length === 1;
    });
    if (!ok) return secs;
    var maps = secs.map(function (s) {
      var m = {};
      s.rows.forEach(function (r) {
        var v = null; r.cells.forEach(function (c) { if (c.val && v == null) v = c.val; });
        m[(r.label || '').toUpperCase()] = v || '';
      });
      return m;
    });
    var order = [];
    secs.forEach(function (s) {
      s.rows.forEach(function (r) {
        var L = (r.label || '').toUpperCase();
        if (L && order.indexOf(L) < 0) order.push(L);
      });
    });
    var cols = secs.map(function (s) { return s.title; });
    var rows = order.map(function (L) {
      return {
        label: L,
        cells: secs.map(function (s, i) { return { val: maps[i][L] || '', _col: cols[i] }; })
      };
    });
    return [{ title: '', kind: 'sizes', hasLabel: true, columns: cols, rows: rows }];
  }

  function num(s) { var m = String(s).match(/-?[0-9]*\.?[0-9]+/g); return m; }
  function convertVal(val, unit) {
    // unit: 'cm'|'mm'. Convert every number in the string to inches, keep separators.
    var div = unit === 'mm' ? 25.4 : 2.54;
    var out = val.replace(/-?[0-9]*\.?[0-9]+/g, function (n) {
      var v = parseFloat(n) / div;
      return (Math.round(v * 10) / 10).toString();
    });
    out = out.replace(/(cm|mm)\b/gi, '').replace(/\s+/g, ' ').trim();
    return out + ' in';
  }
  function cellUnit(val, capUnit) {
    var u = detectUnit(val);
    if (u) return u;
    if (/^[\d.\-\/ ]+$/.test(val) && capUnit && capUnit !== 'in') return capUnit; // bare number inherits caption
    return null;
  }
  function convertible(colKey, val, capUnit) {
    if (SYSTEM_KEYS.test(colKey)) return false;
    if (NONLEN_UNIT.test(val)) return false;
    if (/\bin\b|inch|["\u201d\u2033]/i.test(val)) return false; // already shows inches / dual-unit
    var u = cellUnit(val, capUnit);
    return u === 'cm' || u === 'mm';
  }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // Build the table HTML. Stores cm + in variants inline; JS toggle flips data-unit.
  function renderHTML(p) {
    if (!p.tabular || !p.sections || !p.sections.length) return null;
    var anyConv = false;
    var showTitles = p.sections.length > 1;

    function valCell(v, conv) {
      if (!conv) return '<td>' + esc(v) + '</td>';
      var inVal = convertVal(v, cellUnit(v, p.capUnit) || p.capUnit || 'cm');
      var cmVal = /(cm|mm)\b/i.test(v) ? v : v + (p.capUnit === 'mm' ? ' mm' : ' cm');
      return '<td data-cm="' + esc(cmVal) + '" data-in="' + esc(inVal) + '">' + esc(cmVal) + '</td>';
    }

    function renderSection(sec) {
      var thead, body = '';
      if (sec.kind === 'spec') {
        thead = '<tr><th>Measurement</th><th>Value</th></tr>';
        sec.rows.forEach(function (r) {
          var conv = convertible(r.key, r.val, p.capUnit);
          if (conv) anyConv = true;
          body += '<tr><th scope="row">' + esc(r.key) + '</th>' + valCell(r.val, conv) + '</tr>';
        });
      } else {
        var cols = sec.columns;
        thead = '<tr>' + (sec.hasLabel ? '<th>Size</th>' : '') +
                cols.map(function (c) { return '<th>' + esc(c) + '</th>'; }).join('') + '</tr>';
        sec.rows.forEach(function (r) {
          var map = {};
          r.cells.forEach(function (c, i) { map[c._col || c.key || ('Col' + i)] = c.val; });
          var tds = cols.map(function (c) {
            var v = map[c]; if (v == null || v === '') return '<td>\u2014</td>';
            var conv = convertible(c, v, p.capUnit);
            if (conv) anyConv = true;
            return valCell(v, conv);
          }).join('');
          body += '<tr>' + (sec.hasLabel ? '<th scope="row">' + esc(r.label || '') + '</th>' : '') + tds + '</tr>';
        });
      }
      var titleHtml = (showTitles && sec.title)
        ? '<div class="msg-section">' + esc(sec.title) + '</div>' : '';
      return titleHtml +
        '<div class="msg-scroll"><table class="msg-table"><thead>' + thead + '</thead><tbody>' + body + '</tbody></table></div>';
    }

    var tablesHtml = p.sections.map(renderSection).join('');

    var capText = (p.caption || 'Size Guide').replace(/\s*\((cm|mm|inches?|cm\s*\/\s*inch.*)\)\s*$/i, '').trim() || 'Size Guide';
    var toggle = anyConv
      ? '<div class="msg-toggle" role="group" aria-label="Units">' +
        '<button type="button" class="msg-unit is-active" data-set="cm">CM</button>' +
        '<button type="button" class="msg-unit" data-set="in">INCHES</button></div>'
      : '';
    var noteHtml = '';

    return '<div class="msg" data-unit="cm">' +
             '<div class="msg-head"><span class="msg-cap">' + esc(capText) + '</span>' + toggle + '</div>' +
             tablesHtml + noteHtml +
           '</div>';
  }

  // ---- Browser bootstrap ----
  function enhance(el) {
    if (el.getAttribute('data-msg-done')) return;
    var parsed = parseGuide(el.innerHTML);
    var html = renderHTML(parsed);
    if (!html) { el.setAttribute('data-msg-done', '1'); return; } // prose → leave as-is
    el.innerHTML = html;
    el.setAttribute('data-msg-done', '1');
    var wrap = el.querySelector('.msg');
    el.querySelectorAll('.msg-unit').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var set = btn.getAttribute('data-set');
        wrap.setAttribute('data-unit', set);
        el.querySelectorAll('.msg-unit').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        el.querySelectorAll('td[data-cm]').forEach(function (td) {
          td.textContent = td.getAttribute(set === 'in' ? 'data-in' : 'data-cm');
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-attikar-sizeguide]').forEach(enhance);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    // re-run when a collapsible opens / theme editor injects blocks
    document.addEventListener('shopify:section:load', init);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { parseGuide: parseGuide, renderHTML: renderHTML, stripHtml: stripHtml };
  }
})(this);
